import React, { useState, useEffect } from "react";


import { doc, onSnapshot } from "firebase/firestore"; 
import { db } from "../firebase/config";
import Header from "../Components/Header";
import StatsCard from "../Components/StatsCard";
import StatsVisualization from "../Components/StatsVisualization";

const MasterclassStats = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const [statsData, setStatsData] = useState({});
  const [loading, setLoading] = useState(true);
  const [showVisualization, setShowVisualization] = useState(true);

  useEffect(() => {
    // Set up real-time listener for the events document
    const eventsDocRef = doc(db, "all_events_tracking", "events");
    
    const unsubscribe = onSnapshot(eventsDocRef, (docSnapshot) => {
      if (docSnapshot.exists()) {
        setStatsData(docSnapshot.data());
      } else {
        console.log("No events document found!");
      }
      setLoading(false);
    }, (error) => {
      console.error("Error fetching stats data:", error);
      setLoading(false);
    });

    // Clean up listener on component unmount
    return () => unsubscribe();
  }, []);

  return (
    <div className="flex flex-col h-[100%] ">
      <div className="w-[100%]">
        <Header
          PageName={"Masterclass Stats"}
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
      </div>
      <div className="w-full flex items-start overflow-y-auto scrollbar-thin bg-primary opacity-75 rounded-sm h-full border border-[#ffffff18]">
        <div className="container mx-auto p-4">
          {/* Show loading while fetching data */}
          {loading ? (
            <p className="text-white">Loading stats data...</p>
          ) : (
            <div>
              <div className="flex justify-between items-center mb-4">
                <h1 className="text-3xl font-bold text-white">Event Tracking Data</h1>
                <button
                  onClick={() => setShowVisualization(!showVisualization)}
                  className="px-4 py-2 bg-[#333333] text-white rounded-md hover:bg-[#444444] transition-colors"
                >
                  {showVisualization ? "Hide Chart" : "Show Chart"}
                </button>
              </div>
              
              <StatsCard statsData={statsData} />
              
              {showVisualization && Object.keys(statsData).length > 0 && (
                <StatsVisualization statsData={statsData} />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MasterclassStats;